import styled from '@emotion/styled';
import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '1.125rem',
    letterSpacing: '0.41px',
    color: theme.colors.tabInactive,
    boxSizing: 'border-box',
    display: 'block',
    padding: '0',
    textDecoration: 'none',
    '&:hover': {
        color: theme.colors.tabActive,
        cursor: 'pointer',
    },
    '&.active': {
        color: theme.colors.tabActive,
        textDecoration: 'none',
    },
}));

const BigNavItem: React.FC<NavLinkProps> = ({ children, ...rest }) => {
    return <StyledNavLink {...rest}>{children}</StyledNavLink>;
};

export default BigNavItem;
